(() => {
  const init = () => {
    document.querySelectorAll('[data-mn-promo-dock]').forEach((dock) => {
      if (dock.dataset.ready) return;
      dock.dataset.ready = 'true';
      const track = (name, promotion, source) => {
        if (typeof window.gtag === 'function') window.gtag('event', name, {promotion_name:promotion, source});
      };
      const cards = Array.from(dock.querySelectorAll('[data-mn-promo]'));
      const hero = document.querySelector('.mnr-hero');
      const isDesigner = location.pathname === '/pages/neon-customizer' || location.pathname === '/pages/is-your-wall-boring' || location.pathname === '/products/ai-customizer-product' || !!document.querySelector('[data-mn-customizer]');
      let heroVisible = !!hero;
      const update = () => {
        dock.hidden = isDesigner || heroVisible || cards.every((card) => card.hidden);
        dock.classList.toggle('mncp-dock--single', cards.filter((card) => !card.hidden).length === 1);
      };
      cards.forEach((card) => {
        const key = `mn-promo-dismissed-${card.dataset.mnPromo}-v2`;
        let dismissed = false;
        try { dismissed = sessionStorage.getItem(key) === '1'; } catch {}
        const isFan = card.dataset.mnPromo === 'fan_chains';
        card.hidden = dismissed || isFan;
        let showTimer;
        card.querySelector('[data-mn-promo-close]').addEventListener('click', () => {
          clearTimeout(showTimer);
          card.hidden = true;
          try { sessionStorage.setItem(key, '1'); } catch {}
          track(card.dataset.mnPromo === 'create_your_design' ? 'customizer_promo_dismiss' : 'fan_chain_promo_dismiss', card.dataset.mnPromo, 'visual_card');
          update();
        });
        if (isFan && !dismissed) showTimer = setTimeout(() => {
          card.hidden = false;
          track('fan_chain_promo_view', card.dataset.mnPromo, 'visual_card');
          update();
        }, 6000);
        else if (!card.hidden) track('customizer_promo_view', card.dataset.mnPromo, 'visual_card');
      });
      update();
      if (hero && typeof IntersectionObserver === 'function') {
        const observer = new IntersectionObserver(([entry]) => {
          heroVisible = entry.isIntersecting;
          update();
        });
        observer.observe(hero);
      }
    });
  };
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (link?.pathname === '/pages/neon-customizer' && typeof window.gtag === 'function') {
      window.gtag('event', 'customizer_open', {promotion_name:'create_your_design', source:link.dataset.mnCustomizerLink || 'website_link'});
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();
